import CONST from '../constants'

import LoaderChip from './LoaderChip'
import ReadyChip from './ReadyChip'
import DownloadedChip from './DownloadedChip'
import DownloadingChip from './DownloadingChip'
import PartialChip from './PartialChip'
import ErrorChip from './ErrorChip'

export function stateToChip(state) {
  const { STATE } = CONST
  switch (state) {
    case STATE.Loading:
      return LoaderChip

    case STATE.Ready:
      return ReadyChip

    case STATE.Downloaded:
      return DownloadedChip

    case STATE.Downloading:
      return DownloadingChip

    case STATE.PartialDownload:
      return PartialChip

    case STATE.Error:
      return ErrorChip

    default:
      return null
  }
}

export default {
  LoaderChip
}
